// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"62a43f57","435":"a28f7910","496":"c2065d93"}[chunkId] + ".chunk.js";
};